import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { RenderedService } from '../../rendered.service';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { ViewModalComponent } from '@scaffold/dialogs/view-modal/view-modal.component';
import {
  ScaffoldDialogService,
  ScaffoldDialogRef,
} from '@app/framework/dialog/scaffold-dialog.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
    selector: 'scaffold-view',
    templateUrl: './scaffold-view.component.html',
    styleUrls: [
        '../../rendered.component.scss',
        './scaffold-view.component.scss',
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ScaffoldViewComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  public destroy$: Subject<boolean> = new Subject<boolean>();
  dialogRef: ScaffoldDialogRef;

  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    public dialog: ScaffoldDialogService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe(trigger => {
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
  openView(mode: any, item: any) {
    let navItem = item || this.info.children || this.info;
    console.log(mode, navItem);
    if (this.item.link_location == 'view')
      return this.openLinkHandler(navItem || { type: mode });
    let settings: any = {
      context: {
        data: {
          mode: mode,
          item: navItem,
          //   parent: parent || this.info
        },
      },
    };
    this.dialogRef = this.dialog.open(ViewModalComponent, settings);
    this.dialogRef.onClose.subscribe(result => {
      console.log(result);
      console.log(this.item);
      console.log(this.info);
      if (result && (result !== 'string' || result.length > 0)) {
        if (this.item && this.item.list_view) {
        }
      }
    });
  }
  openLinkHandler(item: any) {
    console.log(item);
    var navConfig = {};
    if (this.activatedRoute?.parent?.component) {
      navConfig['relativeTo'] = this.activatedRoute.parent;
    }
    if (item.id) {
      this.router.navigate([item.type, item.id], navConfig);
    } else {
      this.router.navigate([item.type], navConfig);
    }
  }
}
